import React, { createContext, useCallback, useContext, useState } from 'react';
import { SupportDialog } from './SupportDialog';

interface SupportDialogContextValue {
  openSupportDialog: () => void;
}

const SupportDialogContext = createContext<SupportDialogContextValue | undefined>(undefined);

export const SupportDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openSupportDialog = useCallback(() => setOpen(true), []);
  const closeSupportDialog = useCallback(() => setOpen(false), []);

  return (
    <SupportDialogContext.Provider value={{ openSupportDialog }}>
      {children}
      <SupportDialog open={open} onClose={closeSupportDialog} />
    </SupportDialogContext.Provider>
  );
};

export function useGlobalSupportDialog(): () => void {
  const ctx = useContext(SupportDialogContext);
  if (!ctx) throw new Error('useGlobalSupportDialog must be used within a SupportDialogProvider');
  return ctx.openSupportDialog;
}
